import gsap from 'gsap';
import { ScrollTrigger } from '../libs/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const detectScrollBottomPage = () => {

  // https://ihatetomatoes.net/scrolltrigger-tutorial-toggleactions-toggleclass/
  const featurePost = document.querySelector('.article-featured, .article-container__featured');
  const isBlog = document.querySelector('body.single');

  // Default
  if (!isBlog) {
    if (window.matchMedia('(min-width: 1025px)')) {

      const trigger = document.querySelector('.site-footer');

      ScrollTrigger.create({
        trigger: trigger,
        // once: true,
        start: 'top 100%',
        markers: false,
        toggleActions: "play pause resume reset" // reset tween when scrolling back up the page
      });

      ScrollTrigger.create({
        trigger: trigger,
        start: 'top 100%',
        end: () => `+=${trigger.clientHeight + 266}`, // + added to stop animation canceling when scrolling to bottom of page
        toggleActions: 'play reverse none reverse',
        toggleClass: { targets: featurePost, className: "unlock" },
      });

    }

  }

  // // If is blog page
  else {

    if (window.matchMedia('(min-width: 1025px)')) {

      const trigger = document.querySelector('.trigger-wrap');

      ScrollTrigger.create({
        trigger: trigger,
        // once: true,
        // start: 'top 100%',
        start: 'top bottom',
        markers: false,
        toggleActions: "play pause resume reset" // reset tween when scrolling back up the page
      });

      ScrollTrigger.create({
        trigger: trigger,
        start: 'top bottom',
        end: () => `+=${trigger.clientHeight + 200}`, // + added to stop animation canceling when scrolling to bottom of page
        toggleActions: 'play reverse none',
        toggleClass: { targets: featurePost, className: "unlock" },
        markers: false
      });

    }

  }




}

export default detectScrollBottomPage;